module.exports = __webpack_public_path__ + "img/inlineGroups.118c290b.svg";